import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import templateService from "../../services/templateService";

const useTemplate = (templateId) =>
  useQuery(
    [
      queryKeys.template,
      templateId
    ],
    () => templateService.fetchTemplate(templateId),
    {
      enabled: !!templateId,
    }
  );

export default useTemplate;